"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsTools = require("@airportlabs/js-tools");
var _tokens = require("./tokens");
var redirectToUrlWithRefreshToken = function redirectToUrlWithRefreshToken(url) {
  var href = (0, _jsTools.appendParamsToUrl)(url, {
    token: (0, _tokens.getRefreshToken)()
  });
  _jsTools.authConsole.log("redirectToUrlWithRefreshToken", href);
  window.location.href = href;
};
var _default = exports["default"] = redirectToUrlWithRefreshToken;